<template>
    <div class="page-bar">
        <breadcrumbs/>
        <div class="page-toolbar">
        </div>
    </div>
</template>
<script>
  /* ============
   * Pagebar Component
   * ============
   *
   * todo: add documentation here!
   */
  import { createNamespacedHelpers } from 'vuex'

  const {mapState} = createNamespacedHelpers('app')

  export default {
    data () {
      return {}
    },
    computed: {
      ...mapState({
        appSections: state => state.appSections,
        currentSection: state => state.section
      })
    }
  }
</script>

<style lang="scss">
    .page-bar {
        position: relative;
        z-index: 1;
    }

    .search-wrap {
        // transform: translateY(5px);
    }
</style>



// WEBPACK FOOTER //
// src/app/components/Pagebar.vue